import Logger from '@vp/sumo-logger';

var endpoint = "https://endpoint1.collection.us2.sumologic.com/receiver/v1/http/ZaVnC4dhaV2IIpYz6cmcgSYDzfKjssAHdEloy71Ej9ftga8xOm0VdFvagTxTM6KflaZjsQhzLy7JzOSlPKB8EAg0IFzEOSBgdFHLcoQBB1G7IBIXj2gt1A==";
var interval = 5000;
var logger = new Logger(endpoint, interval);

export { logger as default };
//# sourceMappingURL=logger.js.map
